var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.salesummary")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col right" }, [
          _c("div", { staticClass: "action" }, [
            _c("div", { staticClass: "dropdown item dropdown-filter" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn no-bg text-secondary dropdown-toggle filter",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-filter" }),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.filter")) +
                      "\n              "
                  ),
                  [
                    _vm.query.status === null
                      ? _c("span", { staticClass: "badge badge-secondary" }, [
                          _vm._v(_vm._s(_vm.$t("message.all")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status === "selling"
                      ? _c("span", { staticClass: "badge badge-info" }, [
                          _vm._v(_vm._s(_vm.$t("status.pos.selling")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.status === "closed"
                      ? _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(_vm._s(_vm.$t("status.pos.closed")))
                        ])
                      : _vm._e()
                  ],
                  _vm._v(" "),
                  _vm.query.branch !== null
                    ? [
                        _c("span", { staticClass: "badge badge-secondary" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.selectedBranchName) +
                              "\n                "
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
                _c(
                  "form",
                  {
                    staticClass: "px-3 py-2",
                    staticStyle: { "min-width": "300px" }
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.posbranchname")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.query.branch,
                              expression: "query.branch"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.query,
                                  "branch",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.handleBranchChanged
                            ]
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(_vm._s(_vm.$t("message.all")))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.branches, function(branch, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: branch.branchId }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(branch.name) +
                                    "\n                    "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-0" }, [
                      _c("label", [_vm._v(_vm._s(_vm.$t("message.status")))]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.query.status,
                              expression: "query.status"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.query,
                                  "status",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.handleStatusChanged
                            ]
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(_vm._s(_vm.$t("message.all")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-info",
                              attrs: { value: "selling" }
                            },
                            [_vm._v(_vm._s(_vm.$t("status.pos.selling")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "text-success",
                              attrs: { value: "closed" }
                            },
                            [_vm._v(_vm._s(_vm.$t("status.pos.closed")))]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [
              _vm._v("\n      " + _vm._s(_vm.$t("message.loading")) + "\n    ")
            ])
          : _c("base-table", {
              attrs: { pagination: _vm.$store.state.app.pagination },
              on: { onPageChange: _vm.handlePageChange },
              scopedSlots: _vm._u([
                {
                  key: "thead",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("apps.pos.message.possession"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("apps.pos.message.salestartedtime"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("apps.pos.message.saleendedtime"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("apps.pos.message.saledurationtime")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              _vm._s(_vm.$t("apps.pos.message.transactions"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_vm.$t("apps.pos.message.cashier")))
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.status")))])
                        ])
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "tbody",
                  fn: function() {
                    return [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _vm.posSessions.length === 0
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { colspan: "7" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("message.notfounddata")) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.posSessions, function(item, index) {
                            return _c("tr", [
                              _c(
                                "td",
                                [
                                  _c("router-link-custom", {
                                    attrs: {
                                      to: {
                                        name: "PosTransactionDetail",
                                        query: {
                                          ps_id: item.ps_id,
                                          ps_code: item.ps_code
                                        }
                                      },
                                      text: item.ps_code,
                                      to_appid: 1,
                                      current_appid: 1
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getDateTime(item.started_at)) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                item.ended_at
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getDateTime(item.ended_at)
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getDurationFriendlyBySeconds(
                                        (_vm
                                          .moment(item.ended_at || new Date())
                                          .format("x") -
                                          _vm
                                            .moment(item.started_at)
                                            .format("x")) /
                                          1000,
                                        _vm.$t,
                                        false
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      item.transactionInfo
                                        ? item.transactionInfo.count
                                        : 0
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  item.user
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.user.email ||
                                                item.user.username
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  [
                                    item.status == "selling"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-info" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("status.pos.selling")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "paused"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-warning" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("status.pos.paused")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == "closed"
                                      ? _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("status.pos.closed")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ],
                                2
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e627208", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e627208","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/transaction/All.vue
// module id = null
// module chunks = 